import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAcP2jhAJzxvmFmADGtXEkD3mbbh-qkHu4",
    authDomain: "dreamhome-jalandhar.firebaseapp.com",
    databaseURL: "https://dreamhome-jalandhar.firebaseio.com",
    projectId: "dreamhome-jalandhar",
    storageBucket: "dreamhome-jalandhar.appspot.com",
    messagingSenderId: "1037460784950",
    appId: "1:1037460784950:web:a3d3a59cd1a1ca00801597",
    measurementId: "G-7XV0XCWH8L"
};

firebase.initializeApp(firebaseConfig);

//save user query message
export function saveUserQueryMessage(name: string, email: string, subject: string, message: string) {
    return firebase.firestore().collection('query-messages').add({
        'name': name,
        'email': email,
        'subject': subject,
        'message': message,
        'date': new Date(new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })).getTime()
    })

}



